// extracted by mini-css-extract-plugin
module.exports = {"checkboxContainer":"app-checkbox-group_checkboxContainer_1UV_y","checkbox":"app-checkbox-group_checkbox_bpnq9","tooltip":"app-checkbox-group_tooltip_23cIy"};